import React, { useEffect } from 'react';
import {
  Alert,
  Body,
  Box,
  Flex,
  InformationIcon,
  Link,
  Spinner,
  WarningIcon,
} from '@edreamsodigeo/prisma-design-system';
import {
  Mobile,
  Show,
  useRouter,
  useTranslation,
} from '@edreamsodigeo/frontend-core';
import { ACTIONS, usePFTracking } from '@/hooks/tracking';

export const InformativeAlert = ({ isActiveLoading }) => {
  const { t } = useTranslation();
  return (
    <Box mb="base" data-testid="summary-informative-alert">
      <Alert theme="soft" type="informative">
        <Flex flexDirection="row" alignItems="top" justifyContent="left">
          <Box pt="tiny" mr="1x_small" minWidth="16px">
            <InformationIcon size="small" color="info.90" />
          </Box>
          <Flex flexDirection="column" gap="1x_small">
            <Box>
              <Body inline type="small" weight="bold">
                {t('pricefreeze.summaryPage.form.contact.infoBoxTitle')}
              </Body>
              <Body inline type="small">
                {t('pricefreeze.summaryPage.form.contact.infoBoxSubtitle')}
              </Body>
              <Show when={isActiveLoading}>
                <Body inline sx={{ paddingLeft: 'small' }}>
                  <Spinner size="tiny" />
                </Body>
              </Show>
            </Box>
          </Flex>
        </Flex>
      </Alert>
    </Box>
  );
};

export const InformativeAlertPhase = () => {
  const { t } = useTranslation();
  return (
    <Box mb="base" data-testid="summary-informative-alert">
      <Alert theme="soft" type="informative">
        <Flex flexDirection="row" alignItems="top" justifyContent="left">
          <Box pt="tiny" mr="1x_small" minWidth="16px">
            <InformationIcon size="small" color="info.90" />
          </Box>
          <Flex flexDirection="column" gap="1x_small">
            <Box>
              <Body inline type="small">
                {t('pricefreeze.primefirst.contact.subtitle.second')}
              </Body>
            </Box>
          </Flex>
        </Flex>
      </Alert>
    </Box>
  );
};

export const CriticalAlert = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { track } = usePFTracking();
  const onBack = () => {
    track(
      ACTIONS.HOMEPAX.CLICK.BACKTOTRIPSUMMARY,
      'pf_summary_details',
      'home_pax'
    );
    router.back();
  };

  useEffect(() => {
    track(ACTIONS.HOMEPAX.ERRORONLOAD, 'pf_summary_details', 'home_pax');
  }, [track]);
  return (
    <Box mb="base" data-testid="summary-critical-alert">
      <Alert theme="soft" type="critical">
        <Flex flexDirection="row" alignItems="top" justifyContent="left">
          <Box mr="1x_small" minWidth="24px">
            <WarningIcon size="medium" color="critical.90" />
          </Box>
          <Flex flexDirection="column" gap="1x_small">
            <Box>
              <Body inline type="small" weight="bold" color="critical.90">
                {t('pricefreeze.summaryPage.form.contact.errorBoxTitle')}
              </Body>
              <Body type="small" color="critical.90">
                {t('pricefreeze.summaryPage.form.contact.errorBoxSubtitle')}
              </Body>
              <Mobile>
                <Box pt="1x_small">
                  <Body type="small">
                    <Link onClick={onBack}>
                      {t('pricefreeze.summaryPage.form.contact.errorBoxLink')}
                    </Link>
                  </Body>
                </Box>
              </Mobile>
            </Box>
          </Flex>
        </Flex>
      </Alert>
    </Box>
  );
};
